function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { MedicalRecordContext } from 'context';
import { CGM_INTERVAL } from 'modules/PatientResults/constants';
import messages from 'modules/PatientResults/messages';
import styles from './GlucoseConcentrationLevelsWidget.pcss';
const CGMTimePercentage = ({ readings })=>{
    const medicalRecord = useContext(MedicalRecordContext);
    const { dataType } = medicalRecord;
    if (dataType !== 'CGM') {
        return null;
    }
    const pT = Math.round(readings.length * CGM_INTERVAL / 100);
    return /*#__PURE__*/ _jsx("p", {
        className: styles.cgmTimePercentage,
        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.glucoseConcentrationLevels.cgmTimePercentage), {
            values: {
                pT
            }
        }))
    });
};
export default /*#__PURE__*/ memo(CGMTimePercentage);
